import {ContinuantStatRecord, ProcessParamStatRecord, ProcessStatRecord} from './interface';

export function getProcessId(process: ProcessStatRecord) {
    return process.label;
}

export function getProcessParamId(process: ProcessStatRecord, param: ProcessParamStatRecord) {
    return `${process.label}.${param.label}`;
}

export function getProcessParamValueId(value: ContinuantStatRecord) {
    return `${value.documentAccession}${value.elementNodeId}`;
}
